import React from "react";
import "./Sponsor.css";

function Sponsor({ image, title, url }) {
  return (
    <div className="sponsor">
      <img src={image} alt={title} />
      <div className="sponsor__info">
        <h4>{title}</h4>
        <a href={`http://www.${url}`}>{url}</a>
      </div>
    </div>
  );
}

export default Sponsor;
